





















import Vue from "vue";

import FeedbackCard from "@tt-app/components/feedback/FeedbackCard.vue";
import IconClose from "@joyz/app-core/assets/icons/transparent/Close.svg";
import IconComment from "@joyz/app-core/assets/icons/default/Comment.svg";

export default Vue.extend({
  name: "FeedbackButton",

  components: { FeedbackCard },

  props: {
    logId: {
      type: String,
      default: undefined
    }
  },

  data() {
    return {
      icons: {
        close: IconClose,
        comment: IconComment
      },
      modal: {
        open: false
      },
      submitted: false
    };
  },

  methods: {
    closeFeedback() {
      this.$emit("close");
    },

    handleCloseClick(event: MouseEvent) {
      event.stopPropagation();
      this.closeFeedback();
    },

    handleFeedbackClick(event: MouseEvent) {
      event.stopPropagation();
      this.modal.open = true;
    },

    handleModalClose(event: MouseEvent) {
      event.stopPropagation();

      if (this.submitted) {
        this.closeFeedback();
      }

      this.modal.open = false;
    },

    onFeedbackSubmission() {
      this.submitted = true;
    }
  }
});
